import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import GLOBALVAR from "../constants";
import { Spinner } from "react-bootstrap";

function AutosuggestComponent({ setApplicantDetails, setLoanProcessingDetails }) {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchApplicantAndLoans = async (applicantId) => {
        try {
            setLoading(true);

            // Fetch applicant details
            const applicantResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applications/${applicantId}`);
            const applicantData = applicantResponse.data;

            // Fetch loan processing details for the applicant using the new route
            const loansResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/fetch/by-applicant/${applicantId}`);
            const loanData = loansResponse.data;

            setApplicantDetails(applicantData);
            setLoanProcessingDetails(loanData);
        } catch (error) {
            console.error('Error fetching applicant and loans:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectChange = (selectedOption) => {
        if (selectedOption) {
            setApplicantDetails(null); // Reset details until fetched
            setLoanProcessingDetails([]); // Reset loan details
            fetchApplicantAndLoans(selectedOption.value);
        }
    };

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applicationsearch?query=${value}`);
                const data = response.data;

                if (data && data.rows) {
                    const suggestions = data.rows.map(application => ({
                        label: `${application.lastName}, ${application.firstName} ${application.middleName}`,
                        value: application.id
                    }));
                    setOptions(suggestions);
                } else {
                    setOptions([]);
                }
            } catch (error) {
                console.error('Error fetching suggestions:', error);
            } finally {
                setLoading(false);
            }
        };

        if (value) {
            fetchOptions();
        }
    }, [value]);

    return (
        <>
            <Select
                options={options}
                isLoading={loading}
                onInputChange={setValue}
                value={options.find(option => option.label === value)}
                placeholder="Type a name..."
                onChange={handleSelectChange}
            />
            {loading && <Spinner animation="border" />}
        </>
    );
}

export default AutosuggestComponent;
